import { ForkKnife, Drop, UsersThree, Sparkle } from "@phosphor-icons/react";

const PLANS = [
  {
    icon: ForkKnife,
    eyebrow: "Step one",
    title: "Serve freshly cooked meals every evening",
    body: "We will prepare and serve nourishing meals to every guest, so they can sit down to a real meal at the end of the day.",
  },
  {
    icon: Drop,
    eyebrow: "Step two",
    title: "Distribute hygiene kits, freely",
    body: "Soap, toothbrushes, fresh socks, warm hats, period products, towels — the small essentials that restore dignity, given without forms or questions.",
  },
  {
    icon: UsersThree,
    eyebrow: "Step three",
    title: "Build real community support",
    body: "Conversation, connection, and a steady weekly rhythm. People who know your name and are glad you came. Pathways to local services.",
  },
  {
    icon: Sparkle,
    eyebrow: "Step four",
    title: "Grow with the people we serve",
    body: "Listen first. Adapt to what our neighbors actually need. Add hours, services, and partnerships as the community shapes us into what it needs us to be.",
  },
];

export default function Impact() {
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="py-24 md:py-32 bg-[#5C6B51] relative overflow-hidden"
    >
      <div className="absolute inset-0 paper-grain opacity-20" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="label-eyebrow text-[#E3E9DD] mb-5">Our vision &amp; the road ahead</p>
          <h2 className="font-headline font-light text-4xl md:text-5xl text-[#FDFBF7] leading-tight">
            We're building a place where
            <br />
            <span className="italic">every evening means belonging</span>.
          </h2>
          <p className="mt-6 text-[#E3E9DD]/90 text-lg leading-relaxed">
            Hearthside Gathering exists to create lasting, evening-by-evening impact for the
            unhoused members of our community. The plan is simple, the work is steady, and
            the goal is unmistakable: warmth, food, dignity, and belonging — every single
            night the lantern is lit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PLANS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`impact-plan-${idx}`}
                className="rounded-3xl border border-[#FDFBF7]/15 bg-[#FDFBF7]/[0.04] backdrop-blur-sm p-8 md:p-10 hover:bg-[#FDFBF7]/[0.07] transition-colors duration-300"
              >
                <div className="flex items-start gap-5">
                  <div className="rounded-2xl bg-[#FDFBF7]/10 p-3 flex-shrink-0">
                    <Icon size={28} weight="duotone" className="text-[#FDFBF7]" />
                  </div>
                  <div>
                    <p className="label-eyebrow text-[#E3E9DD] mb-2">{p.eyebrow}</p>
                    <h3 className="font-headline text-2xl md:text-3xl font-medium text-[#FDFBF7] leading-tight">
                      {p.title}
                    </h3>
                    <p className="mt-4 text-[#FDFBF7]/85 leading-relaxed">{p.body}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 md:mt-20 flex justify-center md:justify-start">
          <a
            href="#volunteer"
            data-testid="impact-cta-volunteer"
            className="btn-hearth inline-flex items-center justify-center rounded-full bg-[#FDFBF7] text-[#1F1A17] hover:bg-[#EADAB9] px-7 py-3 text-sm font-semibold tracking-wide"
          >
            Help us open the doors
          </a>
        </div>
      </div>
    </section>
  );
}
